import React from 'react';
import ReadThenSpeak from '../components/ReadThenSpeak';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function ReadThenSpeakPage() {
  return (
    <>
      <Navbar />
      <ReadThenSpeak />
      <Footer />
    </>
  );
}
